import {
  Button,
  TextControl,
  TextareaControl,
  SelectControl,
  Placeholder,
  PanelBody,
  PanelRow,
  TextHighlight,
  ToggleControl,
} from '@wordpress/components';
import {
  MediaUpload,
  MediaUploadCheck,
  useBlockProps,
  InspectorControls,
} from '@wordpress/block-editor';
import { useState } from '@wordpress/element';

export default function Edit({ attributes, setAttributes }) {
  const { slides, padding, title, positiontitle, url, colorbg, container } =
    attributes;
  const [isVisibleBlock, setIsVisibleBlock] = useState(false);
  // Инициализация слайдов, если их нет
  const initSlides = slides;

  // Удаление слайда
  const removeSlide = (slideId) => {
    const updatedSlides = initSlides.filter((slide) => slide.id !== slideId);
    setAttributes({ slides: updatedSlides });
  };

  // Обновление данных слайда
  const updateSlide = (value) => {
    const updatedSlides = [...value];
    setAttributes({ slides: updatedSlides });
  };

  const blockProps = useBlockProps({
    className: 'custom-slider',
  });

  return (
    <>
      <InspectorControls>
        <PanelBody title="Настройки блока" initialOpen={true}>
          <TextControl
            __next40pxDefaultSize
            __nextHasNoMarginBottom={true}
            label="Заголовок блока"
            value={title}
            onChange={(value) => setAttributes({ title: value })}
            placeholder="Введите текст"
          />
          {title && (
            <SelectControl
              __next40pxDefaultSize
              __nextHasNoMarginBottom={true}
              label="Положение заголовка"
              value={positiontitle}
              options={[
                { label: 'Слева', value: '' },
                { label: 'По центру', value: 'justify-content-center' },
              ]}
              onChange={(value) => setAttributes({ positiontitle: value })}
            />
          )}
          <TextControl
            __next40pxDefaultSize
            __nextHasNoMarginBottom={true}
            label="Ссылка в блоке"
            value={url}
            onChange={(value) => setAttributes({ url: value })}
            type="url"
            placeholder="Введите url"
          />
          <SelectControl
            __next40pxDefaultSize
            __nextHasNoMarginBottom={true}
            label="Отступы блока"
            value={padding}
            options={[
              { label: 'Без отступа', value: '' },
              { label: 'Сверху', value: 'pt-5' },
              { label: 'Снизу', value: 'pb-5' },
              { label: 'Сверху и снизу', value: 'py-5' },
            ]}
            onChange={(value) => setAttributes({ padding: value })}
          />
          <ToggleControl
            __nextHasNoMarginBottom={true}
            label="Серый фон"
            checked={colorbg}
            onChange={(value) => setAttributes({ colorbg: value })}
          />
          <ToggleControl
            label="Отключить контейнер"
            help="Нужен для отключения лишних отступов"
            checked={container}
            onChange={(value) => setAttributes({ container: value })}
          />
        </PanelBody>
      </InspectorControls>

      <div {...blockProps}>
        <div className="custom-slider__container">
          <div
            onClick={() => setIsVisibleBlock(!isVisibleBlock)}
            className="custom-slider__title"
          >
            {title ? title : 'Примеры выполненных работ'}
          </div>
          {isVisibleBlock && (
            <div className="custom-slider__wrap">
              <div className="custom-slider__slides">
                <div className="custom-slider__slide">
                  <div className="custom-slider__slide-header">
                    <h3>Картинки</h3>
                    <MediaUploadCheck>
                      <MediaUpload
                        onSelect={(media) => {
                          updateSlide(media);
                        }}
                        allowedTypes={['image']}
                        value={initSlides.map((img) => img.id)}
                        multiple={true}
                        gallery={true}
                        render={({ open }) => (
                          <Button onClick={open} variant="primary">
                            {initSlides.length > 0
                              ? 'Изменить галерею'
                              : 'Выбрать изображения'}
                          </Button>
                        )}
                      />
                    </MediaUploadCheck>
                  </div>
                  {console.log(initSlides)}
                  <div className="custom-slider__grid">
                    {initSlides.length > 0 ? (
                      initSlides.map((slide) => (
                        <div
                          key={slide.id}
                          className="custom-slider__image-wrapper"
                        >
                          <div className="custom-slider__image-container">
                            {slide.url && (
                              <div className="custom-slider__image-preview">
                                <img
                                  src={slide.sizes.medium.url}
                                  alt={slide.alt}
                                />
                                <Button
                                  onClick={() => {
                                    removeSlide(slide.id);
                                  }}
                                  className="custom-slider__remove-image"
                                  variant="primary"
                                >
                                  Удалить изображение
                                </Button>
                              </div>
                            )}
                          </div>
                        </div>
                      ))
                    ) : (
                      <div className="custom-slider__image-preview placeholder"></div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
}
